import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { X, Cookie } from 'lucide-react';

export default function CookieBanner() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) setVisible(true);
  }, []);

  const accept = (type) => {
    localStorage.setItem('cookie_consent', type);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[200] p-4 animate-in slide-in-from-bottom" data-testid="cookie-banner">
      <div className="max-w-4xl mx-auto bg-[#1a2332] border border-white/10 rounded-2xl p-5 shadow-2xl">
        <div className="flex items-start gap-4">
          <Cookie className="w-6 h-6 text-teal-400 flex-shrink-0 mt-0.5" />
          <div className="flex-1">
            <p className="text-slate-300 text-sm leading-relaxed">
              {t('cookie.text')} <button onClick={() => window.dispatchEvent(new CustomEvent('navigate', {detail: 'privacy'}))} className="text-teal-400 hover:underline">{t('cookie.privacyPolicy')}</button> {t('cookie.forMoreInfo')}
            </p>
            <div className="flex flex-wrap gap-3 mt-3">
              <button
                onClick={() => accept('all')}
                className="bg-teal-500 hover:bg-teal-400 text-black font-semibold px-5 py-2 rounded-full text-sm transition-all"
                data-testid="cookie-accept-all"
              >
                {t('cookie.acceptAll')}
              </button>
              <button
                onClick={() => accept('essential')}
                className="bg-white/10 hover:bg-white/15 text-slate-300 font-medium px-5 py-2 rounded-full text-sm transition-all"
                data-testid="cookie-accept-essential"
              >
                {t('cookie.essentialOnly')}
              </button>
            </div>
          </div>
          <button onClick={() => accept('essential')} className="text-slate-500 hover:text-white">
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
